/** @fileoverview list_url_groups の共通定数 */

/** ツール名（単一参照点） */
export const LIST_URL_GROUPS_NAME = "list_url_groups" as const;

/** LLM へ提示する説明文 */
export const LIST_URL_GROUPS_DESC = `Lists URL Groups for a project (works with both Search Analytics and User Analytics).

Use this when a user asks to list, search, or summarize URL Groups for a given project.

Input:
- 'projectId' (required): The ID of the target project.

Notes:
- Read-only. Does not create, update, or delete anything.
- For User Analytics, the returned list includes the virtual "Other" group used for URLs that do not match a configured group.
- Returns: { projectType, analyticsId, urlGroups: [{ id, name, description, op, patterns: [{ type, pattern }] }] }.`;
